exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.task-card[data-v-343d3cd0] {\n  width: 200px;\n  border-radius: 8px;\n  padding: 16px;\n  margin: 12px;\n  border: solid thin #ccc;\n  text-align: left;\n  background: #e7e7e7;\n  position: relative;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-343d3cd0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Calendar/organisms/TrelloBoard.vue
// module id = goeo
// module chunks = 0